/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index toggle-button to autogenerate all the components and extensions
 * Used by "prepareToggleButtons"
 */

import ToggleButton from './toggle-button/ToggleButton'
export * from './toggle-button/ToggleButton'
export default ToggleButton
